import { FC, useEffect } from 'react';
import { useStyles } from './styles';
import { ResetPasswordForm } from 'components/Forms';
import { observer } from 'mobx-react-lite';
import { ReactComponent as LogoIcon } from 'assets/logo.svg';

const UserResetPassword: FC = observer(() => {
  const classes = useStyles();
  useEffect(() => {
    document.title = 'EasyIdentity: User Reset Password';
  }, []);

  return (
    <>
      <LogoIcon style={{ marginLeft: '40px', width: '140px', height: '52px' }} className={classes.logo} />
      <ResetPasswordForm userType='end-user' />
    </>
  );
});

export default UserResetPassword;
